export default __webpack_public_path__ + "static/media/sketch02.beeb2c85.png";